import type { CostBreakdownFormValues } from "../schemas"

export const calculateSharedGrCost = (formValues: Partial<CostBreakdownFormValues>): number => {
  const totalShippingCost =
    formValues.shippingCosts?.reduce((sum, item) => {
      return sum + (item.cost ?? 0)
    }, 0) || 0

  const totalAtypicalSurcharge =
    formValues.atypicalSurcharges?.reduce((sum, item) => {
      return sum + (item.amount ?? 0)
    }, 0) || 0

  const importFeesAmount = formValues.importFees ?? 0
  const insuranceAmount = formValues.insurance ?? 0
  const mpfAmount = formValues.mpf ?? 0
  const hmfAmount = formValues.hmf ?? 0

  return totalShippingCost + totalAtypicalSurcharge + importFeesAmount + insuranceAmount + mpfAmount + hmfAmount
}
